import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useT } from "../i18n/LanguageContext";
import ProtectedEmail from "./ProtectedEmail";

const Footer = () => {
  const { t } = useT();
  return (
    <footer data-testid="site-footer" className="relative bg-[#4c535a] text-[#EFECE6] overflow-hidden">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-8">
              <img src="/logo-white.png" alt="Ordo Rex Studio" className="h-8 w-auto" />
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#EFECE6]/60">Ordo Rex Studio</p>
            </div>
            <Link
              to="/enquiry"
              data-testid="footer-enquire-cta"
              className="inline-block text-[12px] uppercase tracking-[0.28em] link-sweep"
            >
              {t.footer.begin_link}
            </Link>
          </div>

          <div className="md:col-span-3 md:col-start-8 text-[13px] leading-[1.9] text-[#EFECE6]/80 font-sans">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#EFECE6]/50 mb-4">{t.footer.studio}</p>
            {t.footer.studio_lines.map((l) => (
              <p key={l}>{l}</p>
            ))}
            <p className="mt-4 whitespace-pre-line">{t.footer.studio_note}</p>
            <p className="mt-4 italic text-[#EFECE6]/60">{t.footer.studio_langs}</p>
          </div>

          <div className="md:col-span-2 text-[13px] leading-[1.9] font-sans">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#EFECE6]/50 mb-4">{t.footer.navigate}</p>
            <div className="flex flex-col gap-1.5">
              <Link to="/method" data-testid="footer-nav-method" className="link-sweep w-fit">{t.nav.method}</Link>
              <Link to="/services" data-testid="footer-nav-services" className="link-sweep w-fit">{t.nav.services}</Link>
              <Link to="/studio" data-testid="footer-nav-studio" className="link-sweep w-fit">{t.nav.studio}</Link>
              <Link to="/faq" data-testid="footer-nav-faq" className="link-sweep w-fit">{t.nav.faq}</Link>
              <Link to="/enquiry" data-testid="footer-nav-enquiry" className="link-sweep w-fit">{t.nav.enquiry}</Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#EFECE6]/15 flex flex-col md:flex-row md:items-center justify-between gap-6 text-[11px] uppercase tracking-[0.22em] text-[#EFECE6]/55">
          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
            <p>{t.footer.copyright(new Date().getFullYear())}</p>
            <Link to="/impressum" data-testid="footer-nav-impressum" className="link-sweep w-fit">
              {t.footer.impressum}
            </Link>
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
            <ProtectedEmail
              testId="footer-email-link"
              className="lowercase link-sweep w-fit text-[#EFECE6]/80 hover:text-[#EFECE6] transition-colors duration-300"
            />
            <a
              href="https://instagram.com/ordorexstudio"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="instagram-link"
              className="flex items-center gap-2 link-sweep w-fit"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.2} /> @ordorexstudio
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
